import './styles/bootstrap.scss'

// Import bootstrap asynchronously to maintain Module Federation async boundary.
// This is required for standalone Designer operation (designer.matillion.com).
// PE has sync import to prevent race conditions when navigating to PE.
//
// Note: If race conditions occur when navigating to Designer, this may need to be sync.
import('./bootstrap')

export {}
